// Compliance helpers for NZ Contract and Commercial Law Act 2017 (Part 4).
// The Electronic Transactions Act 2002 was repealed on 1 September 2017;
// the equivalent provisions now live here.

export const CONSENT_TEXT =
  "I consent to signing this document electronically under Part 4 of the " +
  "New Zealand Contract and Commercial Law Act 2017. I confirm that I am " +
  "the person named, that the email address (and, where used, mobile " +
  "number) that DocSign reached me on are under my sole control, and that " +
  "the signature I apply is intended to indicate my approval of the " +
  "information in the document.";

// Document classes excluded from electronic signature under CCLA Schedule 5.
// Upload is blocked by default; the admin can only override after typed
// acknowledgement.
const EXCLUDED_PATTERNS = [
  /\bwill\b/i,
  /\btestament\b/i,
  /\bpower\s+of\s+attorney\b/i,
  /\bEPOA\b/,
  /\baffidavit\b/i,
  /\bstatutory\s+declaration\b/i,
  /\bstat\.?\s*dec\b/i
];

export function detectExcludedDocument(titleOrFilename) {
  if (!titleOrFilename) return null;
  const hit = EXCLUDED_PATTERNS.find((re) => re.test(titleOrFilename));
  if (!hit) return null;
  return {
    reason:
      "This document title suggests a category excluded from electronic " +
      "signature under Schedule 5 of the Contract and Commercial Law Act 2017 " +
      "(e.g. wills, enduring powers of attorney, affidavits, statutory " +
      "declarations). Please use a wet-ink signature unless you are certain " +
      "the exclusion does not apply."
  };
}

// E.164 check for New Zealand mobiles: +64 2x xxx xxxx
export function normaliseNzMobile(raw) {
  if (!raw) return null;
  const digits = raw.replace(/[^\d+]/g, "");
  if (/^\+64 ?2\d{7,9}$/.test(digits.replace(/\s/g, ""))) return digits;
  if (/^02\d{7,9}$/.test(digits)) return "+64" + digits.slice(1);
  if (/^642\d{7,9}$/.test(digits)) return "+" + digits;
  return null;
}
